import { Component, HostListener, NgZone, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BodyTypes, GalleryItems } from 'src/app/helpers';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { RatingService } from 'src/app/services/rating/rating.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PublicReportService } from 'src/app/services/public-report/public-report.service';
import { REPORT_ICONS } from 'src/app/components/report-assistant/report.icon';

@Component({
  selector: 'app-report-new',
  templateUrl: './report-new.component.html',
  styleUrls: ['./report-new.component.scss']
})
export class ReportNewComponent implements OnInit {
  public loaded: boolean = false;
  public vehicleBodyTypes: object = {
    bus: BodyTypes.bus,
    suv: BodyTypes.suv,
    sedan: BodyTypes.sedan,
    truckDouble: BodyTypes.truckDouble,
    truckSingle: BodyTypes.truckSingle,
    cargo: BodyTypes.cargo
  };
  public lang: string = null;

  public vinInfo: object = null;
  public information: object[] = [];

  public details: object[] = [];
  public flags: string[] = [];
  public options: object[] = [];
  public galleryData: object[] = [];
  public ratings: object = {};

  public mainImage: string = null;
  public calculatedScore: string | number = null;
  public PerceivedScore: string | number = null;

  public main: Object[] = [];

  public subscriptions: Subscription[] = [];
  public reportInfo: any;
  public accessToken: any;
  public accessvehicleId: any;
  public accessRole: any;
  public accessdata: object = {};
  public getaccessdata: object = {};

  public marketValueChecked: boolean = false;
  public purchaseValueChecked: boolean = false;
  public totalRepairCostChecked: boolean = false;
  publicToken = '';
  // Copy Button
  private $copyBtnLabel = new BehaviorSubject('Copy Link');
  copyBtnLabel = this.$copyBtnLabel.asObservable();

  // ───────────────────────── Redesign helpers ─────────────────────────
  public activeTab: 'exterior' | 'interior' | 'mechanics' | 'frame' | 'major_options' = 'exterior';
  public showMoreSpecs = false;

  public readonly tabs = [
    { key: 'exterior', label: 'Exterior' },
    { key: 'interior', label: 'Interior' },
    { key: 'mechanics', label: 'Mechanics' },
    { key: 'frame', label: 'Frame' },
    { key: 'major_options', label: 'Major Options' }
  ];

  /** Headline specs (label, vinInfo key, icon id) */
  public readonly keySpecs = [
    { label: 'Year', key: 'model_year_id', icon: 'calendar' },
    { label: 'Brand', key: 'make_id', icon: 'tag' },
    { label: 'Model', key: 'model_id', icon: 'car' },
    { label: 'Body Type', key: 'body_type_id', icon: 'body' },
    { label: 'Engine', key: 'engine_type_id', icon: 'engine' },
    { label: 'Transmission', key: 'transmission_type_id', icon: 'shifter' },
    { label: 'Drive Type', key: 'drive_type_id', icon: 'wheel' },
    { label: 'Mileage', key: 'mileage_id', icon: 'gauge' },
    { label: 'Exterior Color', key: 'exterior_color_id', icon: 'palette' },
    { label: 'Trim Type', key: 'trim_id', icon: 'trim' },
    { label: 'RC Expiry Date', key: 'estimara_expiry_date', icon: 'shield' }
  ];

  /** Everything else that used to be in the long "information" block */
  public readonly moreSpecs = [
    { label: 'RC', key: 'estimara_id' },
    { label: 'Engine CC', key: 'engine_cc_id' },
    { label: 'Cylinders', key: 'cyllinder_id' },
    { label: 'Odometer', key: 'odo' },
    { label: 'Fuel Type', key: 'fuel_type_id' },
    { label: 'Gear', key: 'gear_id' },
    { label: 'Vehicle Type', key: 'vehicle_type_id' },
    { label: 'Seats', key: 'seat_id' },
    { label: 'Upholstery', key: 'uphoistery_id' },
    { label: 'Interior Color', key: 'interior_color_id' },
    { label: 'Doors', key: 'door_type_id' },
    { label: 'Country of Origin', key: 'cod_id' },
    { label: 'Wheel Base', key: 'wheel_base_id' },
    { label: 'Utility Type', key: 'utility_type_id' },
    { label: 'Warranty', key: 'warranty_id' },
    { label: 'Warranty Expiry', key: 'warranty_expiry_date' },
    { label: 'Last Service Date', key: 'last_service_date' },
    { label: 'Last Service KM', key: 'last_service_km' },
    { label: 'Service & Maintenance', key: 'service_maintainance' },
    { label: 'Horsepower', key: 'power_id' },
    { label: 'Torque', key: 'torque_id' },
    { label: 'Acceleration', key: 'acceleration_id' },
    { label: 'Max Speed', key: 'max_speed' },
    { label: 'MVPI Expiry', key: 'mvpi_expiry_date' },
    { label: 'Ownership', key: 'ownership_id' },
    { label: 'Mortgage', key: 'mortage_id' },
    { label: 'Origin', key: 'vehicle_origin_id' },
    { label: 'Condition', key: 'vehicle_condition_id' }
  ];

  /** keySpecs + moreSpecs in one stable array (passed to the assistant) */
  public readonly allSpecFields = [...this.keySpecs, ...this.moreSpecs];

  public readonly sectionLinks = [
    { id: 'overview', label: 'Overview' },
    { id: 'specs', label: 'Specifications' },
    { id: 'options', label: 'Options & Flags' },
    { id: 'condition', label: 'Condition' },
    { id: 'gallery', label: 'Gallery' }
  ];

  // bucket base_path
  basePath = environment().base_path;

  val(key: string): string {
    const v = this.vinInfo?.[key];
    if (v && typeof v === 'object') return v['value'] ? String(v['value']) : 'N/A';
    return v ? String(v) : 'N/A';
  }

  money(v: any): string {
    return +v ? 'SAR ' + v : 'N/A';
  }

  /** One place for the grade thresholds that were repeated ~40 times in the template */
  grade(score: any): { cls: string; key: string } | null {
    const s = +score;
    if (!s) return null;
    if (s >= 5) return { cls: 'excellent', key: 'grading.excellent' };
    if (s >= 4.5) return { cls: 'good', key: 'grading.good' };
    if (s >= 4) return { cls: 'v-fair', key: 'grading.v_fair' };
    if (s >= 3.5) return { cls: 'fair', key: 'grading.fair' };
    if (s >= 3) return { cls: 'avg', key: 'grading.average' };
    if (s >= 2.5) return { cls: 'b-avg', key: 'grading.below_average' };
    if (s >= 2) return { cls: 'poor', key: 'grading.poor' };
    if (s >= 1.5) return { cls: 'v-poor', key: 'grading.v_poor' };
    return { cls: 'junk', key: 'grading.junk' };
  }

  /** SVG ring offset for a 0-5 score (circumference of r=52 is 326.7) */
  ringOffset(score: any): number {
    const pct = Math.min(Math.max(+score || 0, 0), 5) / 5;
    return 326.7 * (1 - pct);
  }

  severityLabel(sev: any): string {
    return (
      {
        '1': 'Part change • 1',
        '2': 'Major Repair • 2',
        '3': 'Moderate Repair • 3',
        '4': 'Minor Repair • 4',
        '5': 'Good part • 5'
      }[String(sev)] || 'N/A'
    );
  }

  get categories(): { key: string; label: string; items: any[] }[] {
    return this.tabs.map((t) => ({
      key: t.key,
      label: t.label,
      items: (this.ratings?.[t.key] as any[]) || []
    }));
  }

  public menuOpen = false;

  toggleMenu(ev: Event) {
    ev.stopPropagation();
    this.menuOpen = !this.menuOpen;
  }

  scrollTo(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  public readonly icons = REPORT_ICONS;

  // ───────────────────────── Image viewer (carousel + zoom) ─────────────────────────
  public viewer: { items: { src: string; caption: string }[]; index: number } | null = null;

  private readonly vwMax = 5;
  private vw = { scale: 1, tx: 0, ty: 0 };
  private vwOff: Array<() => void> = [];
  private vwPtrs = new Map<number, { x: number; y: number }>();
  private vwPinch: { d: number; s: number; tx: number; ty: number; cx: number; cy: number } | null =
    null;
  private vwPan: { x: number; y: number; tx: number; ty: number; t: number } | null = null;
  private vwMoved = 0;
  private vwLastTap = { t: 0, x: 0, y: 0 };

  openGallery(index: number) {
    const items = (this.galleryData as any[]).map((g) => ({
      src: g['image'],
      caption: (this.lang === 'ar' ? g['gallery_name_arabic'] : g['gallery_name']) || ''
    }));
    this.openViewer(items, index);
  }

  /** Opens every before/after photo of one part, starting at the clicked one */
  openPartImage(item: any, file: string) {
    const list: { src: string; caption: string }[] = [];
    const add = (arr: any[], label: string) =>
      (arr || []).forEach((img, i) => {
        if (img && img[i + 1]) {
          list.push({
            src: `${this.basePath.slice(0,-1)}${item.image_url}/${img[i + 1]}`,
            caption: `${item.parent_part} · ${label}`
          });
        }
      });
    add(item.vpcs_old_image, 'Before');
    add(item.vpcs_new_image, 'After');
    const src = `${item.image_url}/${file}`;
    this.openViewer(
      list,
      Math.max(
        0,
        list.findIndex((x) => x.src === src)
      )
    );
  }

  openViewer(items: { src: string; caption: string }[], index: number) {
    if (!items.length) return;
    this.viewer = { items, index };
    this.vw = { scale: 1, tx: 0, ty: 0 };
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      this.bindViewer();
      this.vwPreload();
      this.vwApply(false);
      this.vwScrollThumb();
    });
  }

  closeViewer() {
    this.unbindViewer();
    if (this.viewer) document.body.style.overflow = '';
    this.viewer = null;
  }

  goTo(i: number, dir = 0) {
    if (!this.viewer) return;
    const n = this.viewer.items.length;
    this.viewer.index = ((i % n) + n) % n;
    this.vw = { scale: 1, tx: 0, ty: 0 };
    setTimeout(() => {
      this.vwApply(false);
      const img = document.getElementById('rpVwImg');
      if (img && img.animate) {
        img.animate(
          [
            { opacity: 0, transform: `translate3d(${dir * 48}px,0,0) scale(0.98)` },
            { opacity: 1, transform: 'translate3d(0,0,0) scale(1)' }
          ],
          { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' }
        );
      }
      this.vwPreload();
      this.vwScrollThumb();
    });
  }

  step(d: number) {
    if (this.viewer) this.goTo(this.viewer.index + d, d);
  }

  zoomIn() {
    this.vwZoomAt(Math.min(this.vwMax, this.vw.scale * 1.5), 0, 0, true);
  }
  zoomOut() {
    this.vwZoomAt(Math.max(1, this.vw.scale / 1.5), 0, 0, true);
  }
  resetZoom() {
    this.vwZoomAt(1, 0, 0, true);
  }

  @HostListener('document:keydown', ['$event'])
  onViewerKey(e: KeyboardEvent) {
    if (!this.viewer) return;
    switch (e.key) {
      case 'ArrowRight':
        this.step(1);
        break;
      case 'ArrowLeft':
        this.step(-1);
        break;
      case '+':
      case '=':
        this.zoomIn();
        break;
      case '-':
        this.zoomOut();
        break;
      case '0':
        this.resetZoom();
        break;
    }
  }

  private vwPreload() {
    if (!this.viewer) return;
    const { items, index } = this.viewer;
    [index + 1, index - 1].forEach((i) => {
      const it = items[(i + items.length) % items.length];
      if (it) new Image().src = it.src;
    });
  }

  private vwScrollThumb() {
    const el = document.querySelector('.rp-viewer__thumb.is-active') as HTMLElement;
    el?.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }

  private vwApply(animate: boolean) {
    const img = document.getElementById('rpVwImg');
    if (!img) return;
    img.style.transition = animate ? 'transform 0.28s cubic-bezier(.22,1,.36,1)' : 'none';
    img.style.transform = `translate3d(${this.vw.tx}px,${this.vw.ty}px,0) scale(${this.vw.scale})`;
    const pct = document.getElementById('rpVwPct');
    if (pct) pct.textContent = Math.round(this.vw.scale * 100) + '%';
    document.getElementById('rpVwStage')?.classList.toggle('is-zoomed', this.vw.scale > 1.01);
  }

  private vwClamp() {
    const stage = document.getElementById('rpVwStage');
    const img = document.getElementById('rpVwImg');
    if (!stage || !img) return;
    const mx = Math.max(0, (img.offsetWidth * this.vw.scale - stage.clientWidth) / 2);
    const my = Math.max(0, (img.offsetHeight * this.vw.scale - stage.clientHeight) / 2);
    this.vw.tx = Math.min(mx, Math.max(-mx, this.vw.tx));
    this.vw.ty = Math.min(my, Math.max(-my, this.vw.ty));
  }

  /** cx/cy are relative to the stage centre */
  private vwZoomAt(next: number, cx: number, cy: number, animate: boolean) {
    const k = next / this.vw.scale;
    this.vw.tx = cx - (cx - this.vw.tx) * k;
    this.vw.ty = cy - (cy - this.vw.ty) * k;
    this.vw.scale = next;
    if (next <= 1.001) {
      this.vw.scale = 1;
      this.vw.tx = 0;
      this.vw.ty = 0;
    }
    this.vwClamp();
    this.vwApply(animate);
  }

  private vwRel(x: number, y: number) {
    const r = document.getElementById('rpVwStage').getBoundingClientRect();
    return { x: x - (r.left + r.width / 2), y: y - (r.top + r.height / 2) };
  }

  private bindViewer() {
    const stage = document.getElementById('rpVwStage');
    if (!stage) return;
    this.unbindViewer();
    this.ngZone.runOutsideAngular(() => {
      const on = (type: string, fn: any, opts?: any) => {
        stage.addEventListener(type, fn, opts);
        this.vwOff.push(() => stage.removeEventListener(type, fn, opts));
      };
      on('pointerdown', (e: PointerEvent) => this.vwDown(e));
      on('pointermove', (e: PointerEvent) => this.vwMove(e));
      on('pointerup', (e: PointerEvent) => this.vwUp(e));
      on('pointercancel', (e: PointerEvent) => this.vwUp(e));
      on(
        'wheel',
        (e: WheelEvent) => {
          e.preventDefault();
          const c = this.vwRel(e.clientX, e.clientY);
          const f = Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0018));
          this.vwZoomAt(Math.min(this.vwMax, Math.max(1, this.vw.scale * f)), c.x, c.y, false);
        },
        { passive: false }
      );
    });
  }

  private unbindViewer() {
    this.vwOff.forEach((off) => off());
    this.vwOff = [];
    this.vwPtrs.clear();
    this.vwPinch = null;
    this.vwPan = null;
  }

  private vwDown(e: PointerEvent) {
    try {
      (e.currentTarget as HTMLElement).setPointerCapture(e.pointerId);
    } catch (err) {}
    this.vwPtrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (this.vwPtrs.size === 2) {
      const [a, b] = Array.from(this.vwPtrs.values());
      const c = this.vwRel((a.x + b.x) / 2, (a.y + b.y) / 2);
      this.vwPinch = {
        d: Math.hypot(a.x - b.x, a.y - b.y) || 1,
        s: this.vw.scale,
        tx: this.vw.tx,
        ty: this.vw.ty,
        cx: c.x,
        cy: c.y
      };
      this.vwPan = null;
      this.vwMoved = 99;
    } else if (this.vwPtrs.size === 1) {
      this.vwPan = { x: e.clientX, y: e.clientY, tx: this.vw.tx, ty: this.vw.ty, t: Date.now() };
      this.vwMoved = 0;
    }
  }

  private vwMove(e: PointerEvent) {
    if (!this.vwPtrs.has(e.pointerId)) return;
    this.vwPtrs.set(e.pointerId, { x: e.clientX, y: e.clientY });

    if (this.vwPinch && this.vwPtrs.size >= 2) {
      const [a, b] = Array.from(this.vwPtrs.values());
      const c = this.vwRel((a.x + b.x) / 2, (a.y + b.y) / 2);
      const p = this.vwPinch;
      const scale = Math.min(
        this.vwMax,
        Math.max(1, (p.s * Math.hypot(a.x - b.x, a.y - b.y)) / p.d)
      );
      this.vw.scale = scale;
      this.vw.tx = c.x - (p.cx - p.tx) * (scale / p.s);
      this.vw.ty = c.y - (p.cy - p.ty) * (scale / p.s);
      this.vwClamp();
      this.vwApply(false);
      return;
    }

    if (this.vwPan && this.vwPtrs.size === 1) {
      const dx = e.clientX - this.vwPan.x;
      const dy = e.clientY - this.vwPan.y;
      this.vwMoved = Math.max(this.vwMoved, Math.hypot(dx, dy));
      if (this.vw.scale > 1.01) {
        this.vw.tx = this.vwPan.tx + dx;
        this.vw.ty = this.vwPan.ty + dy;
        this.vwClamp();
      } else {
        // carousel drag: image follows the finger
        const single = (this.viewer?.items.length || 0) < 2;
        this.vw.tx = single ? dx * 0.25 : dx;
        this.vw.ty = 0;
      }
      this.vwApply(false);
    }
  }

  private vwUp(e: PointerEvent) {
    if (!this.vwPtrs.has(e.pointerId)) return;
    const wasPinch = !!this.vwPinch;
    this.vwPtrs.delete(e.pointerId);

    if (this.vwPtrs.size === 1) {
      // pinch finished with one finger still down -> continue as a pan
      const [r] = Array.from(this.vwPtrs.values());
      this.vwPinch = null;
      this.vwPan = { x: r.x, y: r.y, tx: this.vw.tx, ty: this.vw.ty, t: Date.now() };
      return;
    }
    if (this.vwPtrs.size > 0) return;

    this.vwPinch = null;
    const pan = this.vwPan;
    this.vwPan = null;

    if (this.vw.scale < 1.02) {
      this.vw.scale = 1;
      if (!wasPinch && pan) {
        const dx = this.vw.tx;
        const stage = document.getElementById('rpVwStage');
        const dt = Math.max(1, Date.now() - pan.t);
        const many = (this.viewer?.items.length || 0) > 1;
        const far = stage ? Math.abs(dx) > stage.clientWidth * 0.18 : false;
        const fast = Math.abs(dx) > 30 && Math.abs(dx) / dt > 0.4;
        if (many && (far || fast)) {
          this.ngZone.run(() => this.step(dx < 0 ? 1 : -1));
          return;
        }
      }
      this.vw.tx = 0;
      this.vw.ty = 0;
      this.vwApply(true);
    }

    // tap / double tap
    if (!wasPinch && pan && this.vwMoved < 10 && Date.now() - pan.t < 300) {
      const now = Date.now();
      const l = this.vwLastTap;
      if (now - l.t < 320 && Math.hypot(e.clientX - l.x, e.clientY - l.y) < 30) {
        const c = this.vwRel(e.clientX, e.clientY);
        this.vwZoomAt(this.vw.scale > 1.01 ? 1 : 2.5, c.x, c.y, true);
        this.vwLastTap = { t: 0, x: 0, y: 0 };
      } else {
        this.vwLastTap = { t: now, x: e.clientX, y: e.clientY };
      }
    }
  }

  /** Parts that are not rated "Good part • 5" */
  defects(items: any[]): any[] {
    return (items || []).filter((i) => i.vpcs_severity && +i.vpcs_severity < 5);
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.closeViewer();
    this.openOption = null;
    this.menuOpen = false;
  }

  // ───────────────────────── Options "+N more" popover ─────────────────────────
  /** Each option card shows this many items; the rest go in a popover */
  public readonly maxOptionItems = 2;
  public openOption: number | null = null;
  public popEnd = false; // popover would overflow the inline-end edge -> align it to the end
  public popUp = true; // always open above the card

  toggleOption(index: number, ev: Event, count: number) {
    ev.stopPropagation();
    if (this.openOption === index) {
      this.openOption = null;
      return;
    }
    const r = (ev.currentTarget as HTMLElement).getBoundingClientRect();
    const width = 260;
    const height = Math.min(60 + count * 30, 280);
    const rtl = this.lang === 'ar';
    this.popEnd = rtl ? r.right - width < 12 : r.left + width > window.innerWidth - 12;
    this.popUp = true;
    this.openOption = index;
  }

  /** Clicking anywhere else closes the popover (clicks inside it stop propagation) */
  @HostListener('document:click')
  closeOption() {
    this.openOption = null;
    this.menuOpen = false;
  }

  // ───────────────────────── Report assistant ─────────────────────────
  // The panel, its chat state and all answering logic live in
  // ReportAssistantComponent / ReportAssistantService (./report-assistant).
  // The floating "Ask AI" button is part of that component; it flips this flag through [(open)].
  public assistantOpen = false;

  constructor(
    private ngZone: NgZone,
    public sharedService: SharedService,
    public ratingService: RatingService,
    public userService: UserService,
    public galleryService: GalleryService,
    public localeService: LocaleService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private route: ActivatedRoute,
    private publicReportService: PublicReportService
  ) {
    try {
      this.hasVinInfo = false;

      if (
        (this.activatedRoute.snapshot.queryParams.access_token &&
          this.activatedRoute.snapshot.queryParams.vehicle_id &&
          this.activatedRoute.snapshot.queryParams.role) ||
        this.activatedRoute.snapshot.queryParams.p ||
        this.activatedRoute.snapshot.queryParams.id
      ) {
        this.sharedService.setQueryParamCheck = true;

        if (
          this.activatedRoute.snapshot.queryParams.p ||
          this.activatedRoute.snapshot.queryParams.id
        ) {
          this.authService.publicToken =
            this.activatedRoute.snapshot.queryParams.p ||
            this.activatedRoute.snapshot.queryParams.id;
        }

        const data = {
          token: this.activatedRoute.snapshot.queryParams.access_token,
          vehicleid: this.activatedRoute.snapshot.queryParams.vehicle_id,
          user: {
            user_data: {
              role: this.activatedRoute.snapshot.queryParams.role
            }
          }
        };

        this.accessdata = data;

        if (Object.keys(this.accessdata).length) {
          this.authService.userSubject.next(this.accessdata);
          localStorage.setItem('user', JSON.stringify(this.accessdata));
          this.sharedService.setVehicleId = this.activatedRoute.snapshot.queryParams.vehicle_id;
        }
        this.getaccessdata = JSON.parse(localStorage.getItem('user') as any);
      }

      // this.getVinDetails();
      // this.allConditions();
      // this.getPlaceholderData();
      this.authService.publicTokenObs.subscribe((token) => {
        this.publicToken = token;
      });
    } catch (err) {
      console.log(err, 'con error');
    }
  }

  public hasVinInfo = false;
  ngOnInit(): void {
    this.hasVinInfo = false;

    try {
      let vinInfo = setInterval(() => {
        const data = JSON.parse(localStorage.getItem('vinInfo'));
        if (
          data ||
          this.activatedRoute.snapshot.queryParams.p ||
          this.activatedRoute.snapshot.queryParams.id
        ) {
          this.vinInfo = data;
          this.getVinDetails();
          this.allConditions();
          this.getPlaceholderData();
          if (data) this.mainParts('Exterior');
          clearInterval(vinInfo);
          if (data) this.hasVinInfo = true;
          if (
            this.activatedRoute.snapshot.queryParams.access_token &&
            this.activatedRoute.snapshot.queryParams.role
          ) {
            localStorage.removeItem('vinInfo');
          }
        }
      }, 1000);
    } catch (err) {
      console.log(err, 'report ngOnIit');
    }

    this.localeService.localeSubject.subscribe((res) => {
      this.lang = res;
    });

    this.sharedService.vinInformation.subscribe((res) => {
      res ? (this.vinInfo = res) : (this.vinInfo = null);
      if (res) {
        this.hasVinInfo = true;
        this.mainParts('Exterior');
      }
    });

    this.mainParts('Exterior');
  }

  ngOnDestroy() {
    this.closeViewer();
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  toggleAssistant() {
    this.assistantOpen = !this.assistantOpen;
  }

  closeAssistant() {
    this.assistantOpen = false;
  }

  getVinDetails() {
    let vehicleId: object = {};
    if (this.sharedService.getVehicleId) {
      vehicleId = {
        vehicle_id: this.sharedService.getVehicleId
      };
    } else {
      let vehiId: any = this.getaccessdata;
      vehicleId = {
        vehicle_id: vehiId.vehicleid
      };
    }

    const informationPublic = this.publicReportService.GetVinInfo(
      this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
    );

    let informationPublicSub: Subscription;

    const informationSub = this.userService
      .GetVinInfo(
        vehicleId,
        this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
      )
      .subscribe(
        (res) => {
          let success = res?.['success'];

          if (success) {
            console.log(success, 'success');
            let data = res['data'];

            this.information =
              data &&
              Object.keys(data ?? {}) &&
              data?.['vehicle_information'] &&
              Object.keys(data?.['vehicle_information'] ?? {})
                ? data?.['vehicle_information']
                : {};
            this.calculatedScore = this.information['calculated_value'];
            this.PerceivedScore = this.information['perceived_value'];
            this.details =
              data && Object.keys(data) && Object.keys(data['vehicle_details'])
                ? data['vehicle_details']
                : {};
            this.options =
              data && Object.keys(data ?? {}) && Object.keys(data['vehicle_options_data'] ?? {})
                ? data?.['vehicle_options_data']?.['options']
                : {};
            const flagsAll =
              data && Object.keys(data) && Object.keys(data['vehicle_flags_data'] ?? {})
                ? data?.['vehicle_flags_data']?.['flags']
                : {};

            for (const key in flagsAll) {
              if (Object.prototype.hasOwnProperty.call(flagsAll, key)) {
                if (flagsAll[key]) {
                  if (this.flags.indexOf(key.replace(new RegExp('_', 'g'), ' ')) === -1) {
                    this.flags.push(key.replace(new RegExp('_', 'g'), ' '));
                  }
                }
              }
            }

            if (
              this.activatedRoute.snapshot.queryParams.p ||
              this.activatedRoute.snapshot.queryParams.id
            ) {
              informationPublicSub = informationPublic.subscribe((res) => {
                let vinInfo = {};

                Object.entries(res['vinInfo'] ?? {})?.map(([key, value]) => {
                  vinInfo = {
                    ...vinInfo,
                    [key]: value
                  };
                });

                this.sharedService.setVinInfo = vinInfo;
              });
            }
          }
        },
        (error) => {}
      );
    this.subscriptions.push(informationSub, informationPublicSub);
  }

  mainParts(type: string) {
    try {
      let data: MainParts = {
        body_type_id: this.vinInfo?.['body_type_id']?.id,
        parts_condition_type: type,
        parent_id: null
      };

      this.loaded = true;
      this.ratingService
        .getPartsCondition(
          data,
          this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
        )
        .subscribe(
          (res) => {
            let success: boolean = res?.['success'];
            let data: Object = res?.['data'];

            if (success) {
              this.loaded = false;
              this.main = data['ratings'];
            }
          },
          (error) => {
            this.loaded = false;
          }
        );
    } catch (err) {
      console.log(err, 'mainParts error');
    }
  }

  allConditions() {
    let data: object = {};
    if (this.sharedService.getVehicleId) {
      data = {
        vehicle_id: this.sharedService.getVehicleId
      };
    } else {
      let vehiId: any = JSON.parse(localStorage.getItem('user') as any);
      data = {
        vehicle_id: vehiId?.vehicleid || this.accessdata['vehicleid']
      };
    }

    this.ratingService
      .getAllConditions(
        data,
        this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
      )
      .subscribe(
        (res) => {
          let success: boolean = res?.['success'];
          if (success) {
            let data: object = res['data'];

            Object.assign(this.ratings, {
              market_value: data['market_value'] || 'N/A',
              purchase_value: data['purchase_value'] || 'N/A',
              total_repair_cost: data['total_repair_cost'] || 'N/A',
              exterior: data['exterior'],
              interior: data['interior'],
              mechanics: data['mechanics'],
              frame: data['frame'],
              major_options: data['major_options']
            });
          }
        },
        (error) => {}
      );
  }

  getPlaceholderData() {
    let getPlaceholderSub = this.galleryService
      .getGalleryPlaceholder(
        this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
      )
      .subscribe(
        (res) => {
          let success: boolean = res['success'];
          let data: Object[] = res['data']['gallerys'];
          let url: string = res['data']['url'];

          if (success) {
            const allItems = data.map((item: any) => ({
              gallery_id: item.gallery_id,
              gallery_name: item.gallery_name,
              gallery_name_arabic: item.gallery_name_arabic,
              gallery_placeholder: `${url}/${item.gallery_placeholder}`,
              isImage: false
            }));

            // this.sharedService.setGallerySubmission = this.allItems;
            this.getGalleryData(allItems);
          }
        },
        (error) => {}
      );
    this.subscriptions.push(getPlaceholderSub);
  }

  getGalleryData(placeholders: Record<string, any>[]) {
    let vehiId: any = JSON.parse(localStorage.getItem('user') as any);
    let vehicleId: any;
    // let vehicleId: string = this.sharedService.getVehicleId;
    if (this.sharedService.getVehicleId) {
      vehicleId = this.sharedService.getVehicleId;
    } else {
      vehicleId = vehiId.vehicleid;
    }

    let getGallerySub = this.galleryService
      .getGallery(
        vehicleId,
        this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
      )
      .subscribe(
        (res) => {
          let success: boolean = res['success'];
          if (success) {
            try {
              let data: object = JSON.parse(
                res['data']['vehicle_gallery_data'] || res['data']['vehicle_auction_data']
              );
              let gallery: Record<string, any>[] = data ? data['parts_images'] : null;
              let url: string = `${this.basePath}storage/${this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id ? 'auction' : 'gallery'}/images/`;
              if (gallery) {
                for (const placeholder of placeholders) {
                  for (const item of gallery) {
                    if (placeholder.gallery_id === item.part_id) {
                      if (item['part_name'] === 'Front') this.mainImage = `${url}${item['image']}`;

                      this.galleryData.push({
                        ...placeholder,
                        image: `${url}${item['image']}`
                      });
                    }
                  }
                }
              }
            } catch (err) {
              console.log(err, 'getGallerySub');
            }
          }
        },
        (error) => {
          console.log(error, 'getGallerySub error');
        }
      );
    this.subscriptions.push(getGallerySub);
  }

  dataTypeChecker(data: any) {
    switch (typeof data) {
      case 'string':
        return 'string';

      case 'object':
        return 'object';

      default:
        return undefined;
    }
  }

  handleMarketValueCheck(event: Event) {
    this.marketValueChecked = (event.target as HTMLInputElement).checked;
  }

  handlePurchaseValueCheck(event: Event) {
    this.purchaseValueChecked = (event.target as HTMLInputElement).checked;
  }

  handleTotalRepairCostCheck(event: Event) {
    this.totalRepairCostChecked = (event.target as HTMLInputElement).checked;
  }

  print() {
    window.print();
  }

  copyReportUrl(event: Event) {
    (async () => {
      await navigator.clipboard.writeText(
        `${window.location.href}?id=${this.publicToken ?? this.authService.publicToken}`
      );
    })();
    const copyBtn = event.currentTarget as HTMLButtonElement;
    const text = copyBtn.querySelector('.copy-text');

    // icons are swapped in CSS via the .copied class
    copyBtn.classList.add('copied');
    text.textContent = 'Copied!';

    setTimeout(() => {
      copyBtn.classList.remove('copied');
      text.textContent = 'Copy';
    }, 1500);
  }
}

interface MainParts {
  body_type_id: string;
  parts_condition_type: string;
  parent_id?: string;
}
